/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CandidateReviewSummary } from './candidateReviewSummary';
import type { CriteriaResultCellSchema } from './criteriaResultCellSchema';
import type { NetworkPathSchema } from './networkPathSchema';
import type { ProfileActivitySummary } from './profileActivitySummary';
import type { ProfileCardSchemaCriteriaBand } from './profileCardSchemaCriteriaBand';
import type { ProfileCardSchemaEducationItem } from './profileCardSchemaEducationItem';
import type { ProfileCardSchemaExperiencesItem } from './profileCardSchemaExperiencesItem';
import type { ProfileCardSchemaHighlights } from './profileCardSchemaHighlights';
import type { ProfileCardSchemaSocialProfilesItem } from './profileCardSchemaSocialProfilesItem';
import type { TalentPoolRefSchema } from './talentPoolRefSchema';

export interface ProfileCardSchema {
  profile_id: string;
  full_name?: string | null;
  headline?: string | null;
  summary?: string | null;
  job_title?: string | null;
  job_company_name?: string | null;
  job_company_domain?: string | null;
  job_company_industry?: string | null;
  location_name?: string | null;
  skills?: string[];
  total_experience_months?: number | null;
  total_experience_years?: number | null;
  current_tenure_months?: number | null;
  has_personal_email?: boolean;
  has_work_email?: boolean;
  has_phone?: boolean;
  linkedin_url?: string | null;
  github_username?: string | null;
  twitter_url?: string | null;
  facebook_url?: string | null;
  social_profiles?: ProfileCardSchemaSocialProfilesItem[];
  education?: ProfileCardSchemaEducationItem[];
  experiences?: ProfileCardSchemaExperiencesItem[];
  highlights?: ProfileCardSchemaHighlights;
  highlight_types?: string[] | null;
  match_score?: number | null;
  viewed?: boolean;
  viewed_at?: string | null;
  review?: CandidateReviewSummary | null;
  avatar_url?: string | null;
  activity?: ProfileActivitySummary | null;
  criteria_score?: number | null;
  criteria_band?: ProfileCardSchemaCriteriaBand;
  criteria_results?: CriteriaResultCellSchema[];
  talent_pool?: TalentPoolRefSchema | null;
  also_in_pools?: TalentPoolRefSchema[];
  network_paths?: NetworkPathSchema[];
}
